<mat-card appearance="outlined">
    <mat-card-header style="background: inherit">
        <!-- <mat-icon class="card-header-icon" style="color: #ffffff" mat-card-avatar>input</mat-icon>
        <mat-card-title>Mapper</mat-card-title> -->
        <mat-card-subtitle>Review the final configuration and commit changes
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>

        <h1 class="center">Review not implemented yet</h1>
    </mat-card-content>
</mat-card>